import { LiquidationSuspenseApplied } from '@willow/types-iso';

import { add, multiply } from './math';

interface LiquidationProceeds {
  remainingBalanceOwed: number;
  totalPaid: number;
}

interface LiquidationSuspenseBalances {
  statementSuspenseBalance: number;
  futureStatementSuspenseBalance: number;
  unappliedSuspenseBalance: number;
}

export const getLiquidationSuspenseApplied = ({
  statementSuspenseBalance,
  futureStatementSuspenseBalance,
  unappliedSuspenseBalance,
}: LiquidationSuspenseBalances): { suspenseApplied: LiquidationSuspenseApplied; totalSuspense: number } => {
  const suspenseApplied = {
    statementSuspense: Math.max(statementSuspenseBalance, 0), // clamping to avoid reducing proceed balance
    futureStatementSuspense: Math.max(futureStatementSuspenseBalance, 0),
    unappliedSuspense: Math.max(unappliedSuspenseBalance, 0),
  };
  return {
    suspenseApplied,
    totalSuspense: add(
      suspenseApplied.statementSuspense,
      suspenseApplied.futureStatementSuspense,
      suspenseApplied.unappliedSuspense,
    ),
  };
};

// A negative `remainingBalanceOwed` means the liquidation proceeds exceeded everything owed; the
// overage is parked in suspense. The gross transaction amount is the proceeds applied to balances
// (`totalPaid`) plus that suspense overage. Shared so the recorded transaction
// (`liquidationToTransactionInput`) and the activity-feed UI can't drift.
export const getLiquidationSuspenseAndAmount = ({ remainingBalanceOwed, totalPaid }: LiquidationProceeds) => {
  const suspense = remainingBalanceOwed < 0 ? multiply(remainingBalanceOwed, -1) : 0;
  return { suspense, amount: add(totalPaid, suspense) };
};
